import { ESearchLocations } from "../types/SearchLocations";

const R = require("ramda");

export const truncateString = R.when(
	R.propSatisfies(R.gt(R.__, 27), "length"),
	R.pipe(R.take(27), R.append("…"), R.join(""))
);

export const getSearchLocations = () => {
	const locations = [];

	for (const key in ESearchLocations) locations.push(key);

	return locations;
};

export const getDropDownItems = (lang) => {
	const items = [];

	let id = 1;

	for (const key in ESearchLocations) {
		items.push({
			id,
			value: ESearchLocations[key].lang[lang],
			queryParam: key,
			checked: false,
		});
		
		id++;
	}
	return items;
};
